import React, { FC } from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { BUSINESS_TRIGGER_CTA } from '@fiverr-private/business_success_sign_modal';
import { useBusinessSignInSteps } from '@fiverr-private/identification_triggers';
import { PAGE_NAME, T_PREFIX } from '../../../lib/constants';

interface SaveButtonProps {
    setIsOpen: (isOpen: boolean) => void;
}

const source = PAGE_NAME;

const SaveButton: FC<SaveButtonProps> = ({ setIsOpen }) => {
    const { signInSteps: onSaveClick } = useBusinessSignInSteps({
        id: `${source}:save-to-list`,
        onSuccess: () => {
            setIsOpen(true);
        },
        activationModalParams: {},
        signInModalParams: {
            source,
            businessTriggerCtaType: BUSINESS_TRIGGER_CTA.SAVE_EXPERT,
            biEnrichmentParams: { source },
        },
        migrateModalParams: {
            source,
            biEnrichment: {
                pageElementName: source,
                trigger: BUSINESS_TRIGGER_CTA.SAVE_EXPERT,
            },
        },
    });

    return (
        <>
            <Button onClick={onSaveClick}>
                <I18n k={`${T_PREFIX}.save_to_list.save_list`} />
            </Button>
        </>
    );
};

export default SaveButton;
